<button (click)="toggleEditMode()">編集切り替え</button>
<ng-container [ngSwitch]="tabletopObject.aliasName">
  <ng-container *ngSwitchCase="'numberResource'">
  </ng-container>
  <ng-container *ngSwitchCase="'card'">
    <button (click)="openModal('front')" [disabled]="!isVisible">表面の画像を変更</button>
    <button (click)="openModal('back')">裏面の画像を変更</button>
  </ng-container>
  <ng-container *ngSwitchCase="'card-stack'">
  </ng-container>
  <ng-container *ngSwitchCase="'terrain'">
    <button (click)="openModal('floor')">床の画像を変更</button>
    <button (click)="openModal('wall')">壁の画像を変更</button>
  </ng-container>
  <ng-container *ngSwitchCase="'dice-symbol'">
    <button (click)="openModal(tabletopObject['face'])" [disabled]="!isVisible">ダイス目の画像を変更</button>
  </ng-container>
  <ng-container *ngSwitchCase="'character'">
    <button (click)="openModalReplaceImage(tabletopObject.imageFiles.length > 1 || 0 < tabletopObject.imageFile?.url.length)">画像{{ (tabletopObject.imageFiles?.length > 1) ? '置換/削除' : '設定' }}</button>
    <button [disabled]="tabletopObject.faceIcons?.length >= MAX_IMAGE_ICON_COUNT" (click)="openModal('faceIcon')">顔IC{{ (tabletopObject.faceIcons?.length > 0) ? '追加' : '設定' }}</button>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <button (click)="openModal('imageIdentifier', tabletopObject.imageFile && tabletopObject.imageFile.url.length > 0)">画像変更</button>
  </ng-container>
</ng-container>
<button (click)="clone()">コピーを作る</button>
<button [disabled]="isSaveing" (click)="saveToXML()">
  <div style="position: relative;">
    <div [ngClass]="{'is-hidden': isSaveing}">保存</div>
    <div *ngIf="isSaveing" class="progress">{{progresPercent}}%</div>
  </div>
</button>
<ng-container *ngIf="tabletopObject.aliasName === 'character'">
  <select *ngIf="tabletopObject" (change)="setLocation($event.target.value)" [ngModel]="tabletopObject.location.name">
    <option value="table">テーブル</option>
    <option value="common">共有インベントリ</option>
    <option value="{{networkService.peerId}}">個人インベントリ</option>
    <option value="graveyard">墓地</option>
  </select>
  <button (click)="openModal('shadowImageIdentifier', tabletopObject.shadowImageFile.url.length > 0)" [disabled]="!tabletopObject.imageElement || tabletopObject.imageElement.value == 'null'">画像の影の変更</button>
</ng-container>
<div *ngIf="tabletopObject" class="flex-container">
  <img class="shadow-image" [src]="tabletopObject.shadowImageFile.url | safe: 'resourceUrl'" [alt]="tabletopObject.shadowImageFile.name" (click)="openModal('shadowImageIdentifier', true)">
  <div *ngIf="(0 < tabletopObject.imageFile?.url.length || 0 < tabletopObject.faceIcons?.length) && tabletopObject.aliasName != 'table-mask'" class="box main-image-box">
    <div class="icons-box">
      <div *ngFor="let faceIconImage of tabletopObject.faceIcons; index as i; trackBy: identify">
        <div @bounceInOut *ngIf="0 < faceIconImage.url.length" class="icon-image-box" [ngClass]="{'current-icon': tabletopObject.currntIconIndex == i}">
          <img [src]="faceIconImage.url | safe: 'resourceUrl'" [alt]="faceIconImage.name" (click)="selectIcon(i)" />
          <button *ngIf="tabletopObject.currntIconIndex == i" class="button-delete-icon" title="顔IC削除" (click)="deleteIcon(i, faceIconImage.identifier)">
            <b class="material-icons" style="font-size: 1rem;">close</b>
          </button>
        </div>
      </div>
    </div>
    <div class="image-showcase" style="position: absolute; height: 50px; top: 300px">
      <span *ngFor="let imageFile of tabletopObject.imageFiles; index as i" class="image-thumbnail" [ngClass]="{'hide': tabletopObject.currntImageIndex == i}" style="position: absolute;" [style.left.px]="(tabletopObject.currntImageIndex <= i ? i-1 : i ) * 50">
        <img @bounceInOut [src]="imageFile.url | safe: 'resourceUrl'" [alt]="imageFile.name" (click)="selectImage(i)">
      </span>
      <button *ngIf="tabletopObject.aliasName == 'character' && tabletopObject.imageFiles.length < MAX_IMAGE_ICON_COUNT && (tabletopObject.imageFiles.length > 1 || 0 < tabletopObject.imageFile?.url.length)"
        (click)="openModalAddImage()"
        style="position: relative; bottom: 30px; z-index: 700;" 
        [style.left.px]="tabletopObject.imageFiles.length < 0 ? -5 : (tabletopObject.imageFiles.length - 1) * 50 - 5">{{ tabletopObject.imageFiles.length < 2 ? '切り替え画像設定' : '＋' }}</button>
    </div>
    <div *ngIf="(tabletopObject.aliasName == 'card' && (tabletopObject.isFront || tabletopObject.isHand)) || (tabletopObject.aliasName == 'card-stack' && tabletopObject.topCard.isFront)"
      class="text" [style.width.px]="imageAreaRreact.width" [style.height.px]="imageAreaRreact.height" [ngStyle]="{transform: 'scale(' + imageAreaRreact.scale + ')'}">
      <div [style.font-size.px]="cardFontSize" [style.color]="cardColor">{{cardText}}</div>
    </div>
    <span style="display: inline-block;" class="inverser" [ngClass]="{inverse: tabletopObject.isInverse}">
      <span class="aura" [ngClass]="{black: tabletopObject.aura == 0, blue: tabletopObject.aura == 1, green: tabletopObject.aura == 2, cyan: tabletopObject.aura == 3, red: tabletopObject.aura == 4, magenta: tabletopObject.aura == 5, yellow: tabletopObject.aura == 6, white: tabletopObject.aura == 7}">
        <img #mainImage class="main-image" [src]="tabletopObject.imageFile.url | safe: 'resourceUrl'" [alt]="tabletopObject.imageFile.name" 
          [ngClass]="{'black-paint': isBlackPaint, 'hollow': tabletopObject.isHollow, small: tabletopObject.aliasName == ''}"
          (dblclick)="openMainImageModal()" 
          (load)="onMainImageLoad()"
          [@switchImage]="tabletopObject.currntImageIndex" />
      </span>
    </span>
  </div>

  <ng-container *ngIf="tabletopObject.commonDataElement">
    <div class="flex-item">
      <div class="table">
        <div class="table-row" game-data-element [gameDataElement]="tabletopObject.commonDataElement" [tableTopObjectName]="tableTopObjectName" [isTagLocked]="true"
          [isHideText]="tabletopObject.aliasName === 'card' && !tabletopObject.isFront && !tabletopObject.isHand" [isNoLogging]="isNoLogging"></div>
      </div>
      <div *ngIf="tabletopObject.aliasName === 'character'" style="text-align: right; margin-top: 3px;">
        <button style="font-size: 11px; color: #444;" (click)="showChatPalette()">チャットパレットを表示</button>
        <button style="font-size: 11px; color: #444;" (click)="showStandSetting()">スタンド設定</button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="tabletopObject.detailDataElement">
    <div class="flex-item" *ngFor="let childElement of tabletopObject.detailDataElement.children">
      <div class="table">
        <div class="table-row" game-data-element [gameDataElement]="childElement" [tableTopObjectName]="tableTopObjectName" [isEdit]="isEdit" [isNoLogging]="isNoLogging"></div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isEdit">
    <div class="flex-item">
      <button style="width:100%; color: #555;" (click)="addDataElement()">新しい項目を追加</button>
    </div>
  </ng-container>
</div>